import React, { useState } from 'react';
import SidebarNav from './SidebarNav';
import TopHeader from './TopHeader';

interface AppShellProps {
  children: React.ReactNode;
}

export default function AppShell({ children }: AppShellProps) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100">
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-60 lg:block">
        <SidebarNav />
      </aside>

      <div className="lg:pl-60">
        <TopHeader onOpenMobileNav={() => setMobileNavOpen(true)} />
        <main className="min-h-[calc(100vh-4rem)]">{children}</main>
      </div>

      {mobileNavOpen && (
        <div className="fixed inset-0 z-40 lg:hidden" role="dialog" aria-modal="true">
          <button
            type="button"
            className="absolute inset-0 bg-black/40"
            aria-label="Close navigation"
            onClick={() => setMobileNavOpen(false)}
          />
          <aside className="absolute inset-y-0 left-0 w-72 bg-white shadow-xl" aria-label="Mobile navigation">
            <SidebarNav onNavigate={() => setMobileNavOpen(false)} />
          </aside>
        </div>
      )}
    </div>
  );
}
